"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLContent = void 0;
const tslib_1 = require("tslib");
const ChannelInstructionType_1 = require("../channelInstruction/ChannelInstructionType");
const MessageType_1 = require("../message/MessageType");
const IResult_1 = require("../shared/IResult");
const Reason_1 = require("../shared/Reason");
const URLContentsUtils_1 = require("./URLContentsUtils");
class URLContent {
    constructor(request, endpointEngagedHandler) {
        this.request = request;
        this.endpointEngagedHandler = endpointEngagedHandler;
    }
    proceed() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.request.payload.channelInstruction.type === ChannelInstructionType_1.ChannelInstructionType.GET_URL_CONTENT) {
                return this.doGETRequest();
            }
            else if (this.request.payload.channelInstruction.type === ChannelInstructionType_1.ChannelInstructionType.POST_URL_CONTENT) {
                return this.doPOSTRequest();
            }
        });
    }
    doGETRequest() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.request.payload.channelInstruction.instructionURI) {
                return this.sendDeclinedEndpointEngaged();
            }
            try {
                const result = yield URLContentsUtils_1.URLContentUtils.makeGETRequest(this.request.payload.channelInstruction.instructionURI);
                const customDataSets = { name: "URLContent", value: JSON.stringify(result) };
                return this.sendAcceptedEndpointEngaged([customDataSets]);
            }
            catch (err) {
                return this.sendDeclinedEndpointEngaged();
            }
        });
    }
    doPOSTRequest() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.request.payload.channelInstruction.instructionURI) {
                return this.sendDeclinedEndpointEngaged();
            }
            try {
                const contents = this.request.payload.interaction.customDataSets;
                const result = yield URLContentsUtils_1.URLContentUtils.makePOSTRequest(this.request.payload.channelInstruction.instructionURI, contents);
                const customDataSets = result ? [{ name: "URLContent", value: JSON.stringify(result) }] : undefined;
                return this.sendAcceptedEndpointEngaged(customDataSets);
            }
            catch (err) {
                return this.sendDeclinedEndpointEngaged();
            }
        });
    }
    sendAcceptedEndpointEngaged(customDataSets) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const request = {
                messageName: MessageType_1.MessageType.EndpointEngagedRequest,
                payload: {
                    channelInstruction: {
                        type: this.request.payload.channelInstruction.type,
                    },
                    messageID: this.request.payload.messageID,
                    interaction: {
                        entersektInteractionID: this.request.payload.interaction.entersektInteractionID,
                        type: this.request.payload.interaction.type,
                        customDataSets,
                    },
                    result: {
                        action: IResult_1.Action.APPROVED,
                    },
                },
            };
            return this.endpointEngagedHandler.endpointEngaged(request);
        });
    }
    sendDeclinedEndpointEngaged() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const request = {
                messageName: MessageType_1.MessageType.EndpointEngagedRequest,
                payload: {
                    channelInstruction: {
                        type: this.request.payload.channelInstruction.type,
                    },
                    messageID: this.request.payload.messageID,
                    interaction: {
                        entersektInteractionID: this.request.payload.interaction.entersektInteractionID,
                        type: this.request.payload.interaction.type,
                    },
                    result: {
                        action: IResult_1.Action.DECLINED,
                        reasons: [Reason_1.Reason.ENDPOINT_DOESNT_SUPPORT],
                    },
                },
            };
            return this.endpointEngagedHandler.endpointEngaged(request);
        });
    }
}
exports.URLContent = URLContent;
//# sourceMappingURL=URLContent.js.map